import type { IDeviceSettingsSlice } from './slice'
import { DEVICE_SETTINGS_SLICE_KEY } from './slice'

/**
 *
 */
export function cameraIdSelector(state: IDeviceSettingsSlice) {
  return state[DEVICE_SETTINGS_SLICE_KEY].cameraId
}

/**
 *
 */
export function microphoneIdSelector(state: IDeviceSettingsSlice) {
  return state[DEVICE_SETTINGS_SLICE_KEY].microphoneId
}

/**
 * Returns the 3AS settings for the microphone.
 */
export function microphone3ASSelector(state: IDeviceSettingsSlice) {
  return {
    microphoneAEC: state[DEVICE_SETTINGS_SLICE_KEY].microphoneAEC,
    microphoneAGC: state[DEVICE_SETTINGS_SLICE_KEY].microphoneAGC,
    microphoneANS: state[DEVICE_SETTINGS_SLICE_KEY].microphoneANS,
  }
}

/**
 *
 */
export function speakerIdSelector(state: IDeviceSettingsSlice) {
  return state[DEVICE_SETTINGS_SLICE_KEY].speakerId
}

/**
 *
 */
export function deviceSettingsActionsSelector(state: IDeviceSettingsSlice) {
  return state[DEVICE_SETTINGS_SLICE_KEY].actions
}

/**
 *
 */
export function failedToGetCameraIdSelector(state: IDeviceSettingsSlice) {
  return state[DEVICE_SETTINGS_SLICE_KEY].failedToGetCameraId
}

/**
 *
 */
export function facingModeSelector(state: IDeviceSettingsSlice) {
  return state[DEVICE_SETTINGS_SLICE_KEY].facingMode
}
